/* sm-magn-listi.js - PROTOTYPE list parser for Magnpontun (bulk ordering).
   Turns whatever the customer pastes into rows for the shared engine:
   one name per line, cells pasted from Excel (tab separated), CSV with ; or ,
   and number ranges such as "101-120, 201-220, 3A-3F, 001-250".
   Plain ES5 IIFE, no dependencies. Works in the browser (window.SMMagnListi)
   and in Node (module.exports) so it can be unit tested.
   Nothing here knows about any product: the template passes its fields. */
(function (root) {
  "use strict";

  var HAMARK_RADIR = 500;        /* Shopify cart line cap, measured */
  var HAMARK_BIL = 500;          /* one range may not expand past this */

  /* Characters that survive engraving in the store fonts. Letters include every
     Icelandic letter, upper and lower case. Anything else is flagged. */
  var LEYFT = /^[A-Za-z0-9ÁÉÍÓÚÝÐÞÆÖáéíóúýðþæöÄäÅåØøÜüÉéÈèÊêÑñÇç .,\-\/&'()+#:@!?’]$/;

  function hreinsa(t) {
    return String(t == null ? "" : t)
      .normalize ? String(t == null ? "" : t).normalize("NFC")
        .replace(/[​-‍﻿]/g, "")      /* zero width, BOM */
        .replace(/[   ]/g, " ")        /* NBSP from Excel/Word */
        .replace(/[‘‛′]/g, "'")
        .replace(/[“”„]/g, '"')
        .replace(/[ \t]+$/g, "").replace(/^[ ]+/g, "")
      : String(t);
  }
  function snyrta(t) { return hreinsa(t).replace(/\s+/g, " ").trim(); }

  /* ---------- ranges ---------- */
  /* "101-120"  "001-250"  "A1-A20"  "A1-20"  "3A-3F"  "1.01-1.12" is NOT a range (kept literal) */
  var BIL_TALA = /^([A-Za-z]{0,3}[ ]?)?(\d{1,6})\s*[-–—]\s*([A-Za-z]{0,3}[ ]?)?(\d{1,6})$/;
  var BIL_STAFUR = /^(\d{0,4})([A-Za-z])\s*[-–—]\s*(\d{0,4})([A-Za-z])$/;

  function bil(tok) {
    var m = BIL_TALA.exec(tok), r = [], i;
    if (m) {
      var fs = (m[1] || ""), fe = (m[3] || "");
      if (fe && fe.toUpperCase() !== fs.toUpperCase()) return null;   /* "A1-B5": not a range we understand */
      var a = parseInt(m[2], 10), b = parseInt(m[4], 10);
      if (b < a) return { villa: "ofugt", texti: tok };
      if (b - a + 1 > HAMARK_BIL) return { villa: "of_stort", texti: tok, fjoldi: b - a + 1 };
      var breidd = m[2].charAt(0) === "0" && m[2].length > 1 ? m[2].length : 0;  /* keep 001 style */
      for (i = a; i <= b; i++) {
        var s = String(i);
        while (breidd && s.length < breidd) s = "0" + s;
        r.push(fs + s);
      }
      return { gildi: r };
    }
    m = BIL_STAFUR.exec(tok);
    if (m && m[1] === m[3]) {
      var up = m[2] === m[2].toUpperCase();
      var x = m[2].toUpperCase().charCodeAt(0), y = m[4].toUpperCase().charCodeAt(0);
      if (y < x) return { villa: "ofugt", texti: tok };
      for (i = x; i <= y; i++) { var c = String.fromCharCode(i); r.push(m[1] + (up ? c : c.toLowerCase())); }
      return { gildi: r };
    }
    return null;
  }

  /* ---------- delimiter detection for multi-field templates ---------- */
  function skiljari(linur, fjoldiReita) {
    var kostir = ["\t", ";", ","], i, j;
    for (i = 0; i < kostir.length; i++) {
      var k = kostir[i], medK = 0;
      for (j = 0; j < linur.length; j++) if (linur[j].indexOf(k) >= 0) medK++;
      /* tab always wins when present; ; and , only when most lines use them and
         the column count fits the template (a comma inside a name is common) */
      if (k === "\t" && medK) return k;
      if (medK && medK >= Math.ceil(linur.length * 0.6)) {
        var passar = 0;
        for (j = 0; j < linur.length; j++) if (klofna(linur[j], k).length <= fjoldiReita) passar++;
        if (passar >= Math.ceil(linur.length * 0.8)) return k;
      }
    }
    return null;
  }
  /* CSV cell split with "quoted; values" */
  function klofna(lina, k) {
    var ut = [], cur = "", q = false, i, ch;
    for (i = 0; i < lina.length; i++) {
      ch = lina.charAt(i);
      if (ch === '"') { if (q && lina.charAt(i + 1) === '"') { cur += '"'; i++; } else q = !q; }
      else if (ch === k && !q) { ut.push(cur); cur = ""; }
      else cur += ch;
    }
    ut.push(cur);
    return ut.map(snyrta);
  }

  /* ---------- main ---------- */
  /* snid.reitir = [{ key: "nafn", heiti: "Nafn", samheiti: ["nafn","name"], hamark: 40 }, ...]
     snid.tolur = true when the product is numbered (room numbers, bag tags):
       tokens may be separated by commas, semicolons, spaces or new lines, and ranges expand.
     Returns { radir: [{ nr, gildi:{key:val}, uppruni, vandamal:[...] }], villur: [...], haus: bool } */
  function lesa(texti, snid) {
    var reitir = snid.reitir, radir = [], villur = [], t = hreinsa(texti).replace(/\r\n?/g, "\n");
    var linur = t.split("\n").map(function (l) { return l.replace(/\s+$/, ""); }).filter(function (l) { return snyrta(l) !== ""; });
    var haus = false;

    if (snid.tolur && reitir.length === 1) {
      linur.join("\n").split(/[\n,;]+|\s{2,}|\t/).forEach(function (tok) {
        tok = snyrta(tok);
        if (!tok) return;
        /* a single space-separated list of plain numbers: "101 102 103" */
        var bitar = /^[\dA-Za-z]+( [\dA-Za-z]+)+$/.test(tok) && !/[-–]/.test(tok) && tok.split(" ").every(function (b) { return /^\d+[A-Za-z]?$/.test(b); }) ? tok.split(" ") : [tok];
        bitar.forEach(function (b) {
          var x = bil(b);
          if (x && x.gildi) x.gildi.forEach(function (g) { radir.push(rod(reitir, [g], b)); });
          else if (x && x.villa) villur.push({ kodi: x.villa === "ofugt" ? "bil_ofugt" : "bil_of_stort", texti: b, fjoldi: x.fjoldi });
          else radir.push(rod(reitir, [b], b));
        });
      });
    } else {
      var k = reitir.length > 1 ? skiljari(linur, reitir.length) : (linur.some(function (l) { return l.indexOf("\t") >= 0; }) ? "\t" : null);
      var raðir = linur.map(function (l) { return k ? klofna(l, k) : [snyrta(l)]; });
      /* header row: first row whose cells all match a field name or synonym */
      if (raðir.length && raðir[0].every(function (c) { return !c || reitaLykill(reitir, c); })) {
        var roun = raðir.shift().map(function (c) { return reitaLykill(reitir, c); });
        haus = true;
        raðir = raðir.map(function (cells) { var ut = []; roun.forEach(function (key, i) { if (key) ut[indexOf(reitir, key)] = cells[i] || ""; }); return ut; });
      }
      raðir.forEach(function (cells, i) {
        if (reitir.length === 1 && snid.bil !== false) {
          var x = bil(cells[0]);
          if (x && x.gildi) { x.gildi.forEach(function (g) { radir.push(rod(reitir, [g], linur[i])); }); return; }
        }
        radir.push(rod(reitir, cells, linur[i]));
      });
    }
    /* per-row checks that do not need the drawing engine */
    var sed = {};
    radir.forEach(function (r, i) {
      r.nr = i + 1;
      reitir.forEach(function (f) {
        var v = r.gildi[f.key] || "";
        if (f.skylda !== false && !v && f === reitir[0]) r.vandamal.push({ kodi: "vantar", reitur: f.key, stopp: true });
        if (f.hamark && v.length > f.hamark) r.vandamal.push({ kodi: "of_langt", reitur: f.key, stopp: true, hamark: f.hamark });
        var bann = [];
        Array.from ? Array.from(v).forEach(function (ch) { if (!LEYFT.test(ch) && bann.indexOf(ch) < 0) bann.push(ch); }) : null;
        if (bann.length) r.vandamal.push({ kodi: "bannstafur", reitur: f.key, stopp: true, stafir: bann });
      });
      var lykill = reitir.map(function (f) { return (r.gildi[f.key] || "").toLowerCase(); }).join("\u0001");
      if (sed[lykill]) r.vandamal.push({ kodi: "tvitekid", stopp: false, somu: sed[lykill] });
      else sed[lykill] = r.nr;
    });
    if (radir.length > HAMARK_RADIR) villur.push({ kodi: "of_margar", fjoldi: radir.length, hamark: HAMARK_RADIR });
    return { radir: radir, villur: villur, haus: haus };
  }
  function indexOf(reitir, key) { for (var i = 0; i < reitir.length; i++) if (reitir[i].key === key) return i; return -1; }
  function reitaLykill(reitir, c) {
    var n = snyrta(c).toLowerCase().replace(/[:.]$/, "");
    for (var i = 0; i < reitir.length; i++) {
      var s = [reitir[i].key, reitir[i].heiti].concat(reitir[i].samheiti || []).map(function (x) { return String(x).toLowerCase(); });
      if (s.indexOf(n) >= 0) return reitir[i].key;
    }
    return null;
  }
  function rod(reitir, cells, uppruni) {
    var g = {};
    reitir.forEach(function (f, i) { g[f.key] = snyrta(cells[i] || ""); });
    return { nr: 0, gildi: g, uppruni: uppruni, vandamal: [] };
  }

  /* ---------- back out: ranges collapsed for the cart summary ---------- */
  /* ["101","102","103","105","201"] -> "101-103, 105, 201" */
  function thjappa(gildi) {
    var ut = [], i = 0;
    function hluti(s) { var m = /^(.*?)(\d+)$/.exec(s); return m ? { f: m[1], n: parseInt(m[2], 10), w: m[2].length, z: m[2].charAt(0) === "0" } : null; }
    while (i < gildi.length) {
      var a = hluti(gildi[i]), j = i;
      if (a) {
        while (j + 1 < gildi.length) {
          var b = hluti(gildi[j + 1]);
          if (!b || b.f !== a.f || b.n !== a.n + (j + 1 - i) || (a.z && b.w !== a.w)) break;
          j++;
        }
      }
      ut.push(j - i >= 2 ? gildi[i] + "-" + gildi[j] : (j > i ? gildi.slice(i, j + 1).join(", ") : gildi[i]));
      i = j + 1;
    }
    return ut.join(", ");
  }

  /* ---------- CSV out (Excel in Iceland expects ; and a BOM for UTF-8) ---------- */
  function csv(radir, reitir) {
    function reitur(v) { v = String(v == null ? "" : v); return /[";\n]/.test(v) ? '"' + v.replace(/"/g, '""') + '"' : v; }
    var linur = [reitir.map(function (f) { return reitur(f.heiti); }).join(";")];
    radir.forEach(function (r) { linur.push(reitir.map(function (f) { return reitur(r.gildi[f.key]); }).join(";")); });
    return "﻿" + linur.join("\r\n") + "\r\n";
  }

  var API = { lesa: lesa, bil: bil, thjappa: thjappa, csv: csv, snyrta: snyrta, HAMARK_RADIR: HAMARK_RADIR };
  if (typeof module !== "undefined" && module.exports) module.exports = API;
  else root.SMMagnListi = API;
})(this);
